import { Routes, Route, useMatch } from "react-router-dom";
import adminRoutes from "@admin/adminRoutes";
import studentRoutes from "@student/studentRoutes";

const Routers = () => {
  const matchUrl = useMatch("/admin/*");

  const routes = matchUrl !== null ? adminRoutes : studentRoutes;

  return (
    <Routes>
      {routes?.map((route) => (
        <Route key={route.path} path={route.path} element={route.element}>
          {route.routes?.map((subRoute) => (
            <Route
              key={subRoute.path}
              path={subRoute.path}
              element={subRoute.element}
            />
          ))}
        </Route>
      ))}
    </Routes>
  );
};

export default Routers;
